import * as React from 'react';
import InputHandler from 'Components/InputHandler';
import { fm } from 'Components/FormatMessage';
import colors from '../../../../../../config/theme/colors';
import type { IExtendedSearchField } from '../ExtendedSearchField';
import type { TESSearchFields } from '../../definitions';

const RelapseField = ({ field, searchFields, onChange, value }: IOwnProps): React.JSX.Element => {
  const handleChange = (values: TOnChangeValues): void => {
    const thisName = Object.keys(values)[0];
    if (!thisName) return;
    const thisValue = values[thisName];

    switch (field.name) {
      case 'relapseDuringLast24Months':
        if (thisValue === 'no' && searchFields.relapseDuringLast12Months !== 'noCropping') {
          onChange({
            relapseDuringLast24Months: thisValue,
            relapseDuringLast12Months: 'noCropping',
            numberOfRelapses: 'noCropping',
          });
        } else {
          onChange({ relapseDuringLast24Months: thisValue });
        }
        break;
      case 'relapseDuringLast12Months':
        if (thisValue === 'no' && searchFields.numberOfRelapses !== 'noCropping') {
          onChange({
            relapseDuringLast12Months: 'no',
            numberOfRelapses: 'noCropping',
          });
        } else {
          onChange({ relapseDuringLast12Months: thisValue });
        }
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <InputHandler
        type="Radio"
        editing={true}
        name={field.name}
        formData={{
          onChange: handleChange,
          document: { [field.name]: value === 'noCropping' ? undefined : value },
        }}
        options={['yes', 'no']}
        optionFormatter={(name: string | number): string | React.JSX.Element => fm(`extendedSearch.opts.${name}`)}
      />
      {searchFields.relapseDuringLast12Months === 'yes' && (
        <React.Fragment>
          <div style={{ fontSize: '1.4rem', color: colors.tertiaryText, marginBottom: '1rem' }}>
            {fm('extendedSearch.numberOfRelapses')}
          </div>
          <InputHandler
            type="Radio"
            editing={true}
            name="numberOfRelapses"
            formData={{
              onChange: onChange,
              document: {
                numberOfRelapses:
                  searchFields.numberOfRelapses === 'noCropping' ? undefined : searchFields.numberOfRelapses,
              },
            }}
            options={['1', '2', '3', 'more']}
            optionFormatter={(name: string | number): string | React.JSX.Element => fm(`extendedSearch.opts.${name}`)}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'field' | 'searchFields' | 'onChange'> {
  value: TESSearchFields[keyof TESSearchFields];
}

export default RelapseField;
